<script lang="ts">
    import { push } from "svelte-spa-router";
    import { onMount } from "svelte";
    import { isAlticeStore } from "../../stores/isAlticeStore";
    import { detectAltice } from "../../utils/detectAltice";
    import { translation } from "../../stores";
    import { getLang } from "../../utils/window";
    import { addToast } from "../../stores/toastStore";
    import CustomButton from "../Custom/CustomButton.svelte";
    import { buildLog } from "../../utils/log";
    import { ROOM_CONNECTION_STATE } from "../../types/Room/RoomConnectionState";

    export let params: Record<string, string> = {};

    let roomId: number | null = null;
    let agreed = false;

    let roomIsDefined = params.room !== null && params.room !== undefined;

    onMount(() => {
        detectAltice();

        if (roomIsDefined) {
            const parsed = parseInt(params.room);
            if (!isNaN(parsed)) {
                roomId = parsed;
                buildLog({
                    roomId,
                    status: ROOM_CONNECTION_STATE.CONNECTED,
                    page: "HomeClient",
                    message: "Client connected on HomeClient page",
                });
            }
        }
    });

    function submit(): void {
        if (!agreed) {
            addToast("error", translation.alert.cguMissing);
            return;
        }
        if (!roomId) {
            addToast("error", translation.alert.roomNumberMissing);
            return;
        }

        push(`/call/${roomId}?lang=${getLang()}&role=client`);
    }
</script>

<!-- INTRODUCTION SECTION -->
<p>
    {translation.intro.part1}<br /><br />
    {translation.intro.part2}
</p>
<ul>
    <li>{translation.intro.li1}</li>
    <li>{translation.intro.li2}</li>
    <li>{translation.intro.li3}</li>
</ul>

<form>
    {#if !roomIsDefined}
        <div class="m-5">
            <label>
                {translation.intro.inputRoomNumber}
                <input
                    bind:value={roomId}
                    style="max-width: 10rem;"
                    type="number"
                />
            </label>
        </div>
    {/if}

    <label class="text-sm flex items-start">
        <input
            style="margin: {$isAlticeStore ? '0.325' : '0.2'}rem;"
            bind:checked={agreed}
            type="checkbox"
        />
        <div>
            {$isAlticeStore
                ? translation.intro.cgu1.replace("SFR", "Altice")
                : translation.intro.cgu1}
            <br />
            {translation.intro.cgu2}
            <a
                class="text-info"
                href="https://www.sfr.fr/politique-de-protection-des-donnees-personnelles.html"
                target="_blank">{translation.intro.policy1}</a
            >
            {translation.intro.policy2}
        </div>
    </label>
    <p
        style="margin: {$isAlticeStore ? '1.325' : '1.2'}rem;"
        class="text-sm text-info text-bold"
    >
        <a href="/doc/CGU{$isAlticeStore ? '_DO' : ''}.pdf" target="_blank"
            >{translation.intro.cguLink}</a
        >
    </p>
    <div class="text-center m-t-xl">
        <CustomButton
            label={translation.intro.startCallButton}
            onClick={submit}
        />
    </div>
</form>

<style>
    .text-info:visited {
        color: var(--info);
    }
    li:before {
        content: "- ";
    }
</style>
